<svg
  [attr.width]="iconSize().width"
  [attr.height]="iconSize().height"
  viewBox="0 0 24 30"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
>
  <rect x="0" y="10" width="4" height="10" fill="#C1D91C" opacity="0.2">
    <animate
      attributeName="opacity"
      values="0.2; 1; 0.2"
      begin="0s"
      dur="0.6s"
      repeatCount="indefinite"
    />
    <animate
      attributeName="height"
      values="10; 20; 10"
      begin="0s"
      dur="0.6s"
      repeatCount="indefinite"
    />
    <animate attributeName="y" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
  </rect>
  <rect x="8" y="10" width="4" height="10" fill="#C1D91C" opacity="0.2">
    <animate
      attributeName="opacity"
      values="0.2; 1; 0.2"
      begin="0.15s"
      dur="0.6s"
      repeatCount="indefinite"
    />
    <animate
      attributeName="height"
      values="10; 20; 10"
      begin="0.15s"
      dur="0.6s"
      repeatCount="indefinite"
    />
    <animate
      attributeName="y"
      values="10; 5; 10"
      begin="0.15s"
      dur="0.6s"
      repeatCount="indefinite"
    />
  </rect>
  <rect x="16" y="10" width="4" height="10" fill="#C1D91C" opacity="0.2">
    <animate
      attributeName="opacity"
      values="0.2; 1; 0.2"
      begin="0.3s"
      dur="0.6s"
      repeatCount="indefinite"
    />
    <animate
      attributeName="height"
      values="10; 20; 10"
      begin="0.3s"
      dur="0.6s"
      repeatCount="indefinite"
    />
    <animate
      attributeName="y"
      values="10; 5; 10"
      begin="0.3s"
      dur="0.6s"
      repeatCount="indefinite"
    />
  </rect>
</svg>
